import SessionEventProto from "../session-event-proto";
import {openGDSystemLink} from "../../gd/utils/gd-system-link";

export default class SessionEvent_OpenSystemLink extends SessionEventProto {

    constructor(sessionEvent:any) {
        super(sessionEvent)
    }

    process() {

        if (this.isDifferentCompany()) return false;

        // gd://request-form/ID

        openGDSystemLink(this.data.systemLink)
    }
};